<template>
 <v-container>
   <br>

    <v-row class="text-center" v-if="!beginTrue">
      
<v-col class="" cols="12">
        <v-card
        elevation="6"
        shaped
        color="blue lighten-3"
        >
<v-list-item three-line>
      <v-list-item-content>
        <div class="text-overline">
          Gamsat Essay Simulator
        </div>
        <v-list-item-title class="text-p mb-1">
          Practise your essay writing skills under exam conditions - we'll set it all up for you, just choose your topic below.
        </v-list-item-title>
        <v-list-item-title class="text-p mb-1">
          
        </v-list-item-title>
       <v-list-item-title class="text-p mb-1">
          
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
      </v-card>
      </v-col>
      <v-col class="mb-4">
         
       
        <!-- SELECT ELEMENT FOR THEME
          These should come directly from the "category" tag in the theme database.
          
          When a theme is selected, 4 quotes and their respective authors should be loaded
          into the quote box once the user hits the "Begin" button.

          "Random Theme" option should be set as default, 
          which selects a random theme and provides 4 quotes from it.
          The theme will be made known to the user after they have completed their essay.
        
        -->
  <template>
  <v-layout justify-center>
  <v-sheet class="pa-5">
    <v-switch
      v-model="isRandomTheme"
      color="blue darken-3"
      inset
      :label="`Random Topic (Recommended)`"
      
    ></v-switch>
  </v-sheet>
  </v-layout>
</template>
        
<template>
        <v-select
          v-if="!isRandomTheme"
          v-model="themeSelected"
          :items="themes"
          label="Choose a Topic"
          dense
          solo
          v-on:change="asyncLoadQuotes()"
        ></v-select>
  </template> 
        <!-- BEGIN BUTTON
          When "Begin" is pressed, the above elements should be hidden and the 
          4 Quuotes displayed.
          The Timer should begin and textarea, finish button displayed
        -->
        <!-- <v-btn @click="begin">Begin</v-btn> -->



        <!-- Dialog Button -->

<template>
  <div class="text-center">
    <v-btn
      elevation="6"
      :disabled="beginDialog"
      :loading="beginDialog"
      class="white--text"
      color="blue darken-2"
      @click="begin"
    >
      Begin
    </v-btn>
    <v-dialog
      v-model="beginDialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="blue lighten-1"
        dark
      >
        <v-card-text align="center">
          Hold tight, we're loading your exam...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

        <!-- End Dialog -->

<!-- START DIALOG -->
        <br><br><br><br><br><br>
        <template>
          <div class="text-center">
            <v-dialog
              transition="dialog-top-transition"
              v-model="dialog"
              max-width="900"
            >
            <template v-slot:activator="{ on, attrs }">
            <v-btn
              x-small
              elevation="4"
              plain
              
              v-bind="attrs"
              v-on="on"
            >
            What's this?
            </v-btn>
            </template>

            <v-card>
             <v-card-title class="text-h5 grey lighten-2">
              Gamsat Simulator: Section II
            </v-card-title>

            <v-card-text>
              <br>
              <b>Use this tool to prepare for Section II of the GAMSAT in the most effective way possible by testing yourself under exam conditions:</b>
              
              <ul>
                <li>You will be presented with 4 comments relating to a specific topic, either selected by you, or at random (in the latter case, which is recommended, the topic is revealed when you have finished writing).</li>
                <li>You are expected to develop a written response to one or more of the comments (see below for more info on how your writing will be assessed in the real exam).
                <li>An on-screen countdown timer is displayed for you to monitor your progress.</li>
                <li>A writing area is available for you to type your response. Spellcheck, Copying and Pasting into the writing area are disabled.</li>
                <li>On completion, you will have the opportunity to download your writing as a Microsoft Word Document. Your writing, as well as the comments you responded to, are all packaged into this document.</li>
              </ul>
              <br>
              <b>Your writing: things to know for the real exam.</b>

              <p>You are expected to develop a piece of writing in response to the comments you are presented with. There are no strict criteria for what is written, the form of the piece, or how many words it should be. However, in the real exam, your writing will be evaluated on the following:</p>
              <p>
                <b>Thought and Content</b> (the quality of what is said).
                <ul>
                  <li>What is made of and developed from the task.</li>
                  <li>The kinds of thoughts offered in response to the task.</li>
                </ul>
              </p>
              <p>
                <b>Organisation and Expression</b> (the quality of the structure developed and language used).
                <ul>
                  <li>The shape and form of the piece.</li>
                  <li>The effectiveness and fluency of the language.</li>
                </ul>
              </p>
              <p>
              In the real exam, each piece of writing is assessed by three independent raters.
              </p>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="purple darken-2"
                dark text
                @click="dialog = false"
              >
            Got it!
              </v-btn>
            </v-card-actions>
            </v-card>
            </v-dialog>
          </div>
        </template>
<!-- End Dialog-->

      </v-col>
      
    </v-row>


    <v-row class="text-center" v-if="beginTrue">
    <v-row class="text-left px-12"> 

      <!-- <v-col class="mb-1" cols="12">
        <p> {{quoteArray[Object.keys(quoteArray)[0]]}} - <i>{{Object.keys(quoteArray)[0]}}</i> </p>

        
      </v-col> -->

      <v-col class="mb-1" cols="12">
        <p v-if="isRandomTheme === false"><b>Topic: </b> {{ themeOutput }}</p>
        <p><i>Consider the following comments and develop a piece of writing in response to one or more of them.</i></p>
        <p> 
          <i>Comment 1 </i>
        </p>
        <p class="mx-16">
                {{quoteArray[Object.keys(quoteArray)[0]]}} 
        </p>
        <p class="mx-16" align="right">
          <i>{{Object.keys(quoteArray)[0]}}</i>
        </p>
        <p class="mb-n1" align="center">
          <b>****</b>
        </p>
        <p> 
          <i>Comment 2 </i>
        </p>
        <p class="mx-16">
                {{quoteArray[Object.keys(quoteArray)[1]]}} 
        </p>
        <p class="mx-16" align="right">
          <i>{{Object.keys(quoteArray)[1]}}</i>
        </p>
        <p class="mb-n1" align="center">
          <b>****</b>
        </p>
        <p> 
          <i>Comment 3 </i>
        </p>
        <p class="mx-16">
                {{quoteArray[Object.keys(quoteArray)[2]]}} 
        </p>
        <p class="mx-16" align="right">
          <i>{{Object.keys(quoteArray)[2]}}</i>
        </p>
        <p class="mb-n1" align="center">
          <b>****</b>
        </p>
        <p> 
          <i>Comment 4 </i>
        </p>
        <p class="mx-16">
                  {{quoteArray[Object.keys(quoteArray)[3]]}} 
        </p>
        <p class="mx-16" align="right">
          <i>{{Object.keys(quoteArray)[3]}}</i>
        </p>
      </v-col>
    </v-row>

    <v-col class="mb-1" cols="12">
      <p><b>Time Remaining: </b> {{ minutesRemaining }}:{{ secondsRemaining }} </p>
    </v-col>

    <v-col class="mb-1" cols="12">
        <v-alert
    v-if="timesUp"
    type="info"
      text
      color="info"
      center
    >
      <h3 class="text-h5">
        Time's up!
      </h3>
      <div>Well done, you have used the allocated time for this written response.</div>

      <v-divider
        class="my-4 info"
        style="opacity: 0.22"
      ></v-divider>

      <v-row
        align="center"
      >
        <v-col>
          <v-btn
            color="info"
            @click="timesUp=!timesUp"
            outlined
          >
            Continue Writing
          </v-btn>
        </v-col>
         
        <v-col>
          <v-btn
            color="info"
            @click="finishTrue=true, timesUp=!timesUp"
            outlined
          >
            Finish Now
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>
    </v-col>

      <v-col class="mb-5" cols="12">
      <!-- TEXTAREA
        Spellcheck, copying, pasting should be disabled during essay writing.
      -->
        <v-textarea
          @keyup="wordCount"
          v-model="essayText"
          spellcheck="false"
          oncopy="return false"
          onpaste="return false"
          onselectstart="return false"
          ondrag="return false"
          ondrop="return false"
          solo
          name="input-7-4"
          label="Write your essay here. On completion, you can download it for future reference."
          background-color="amber lighten-4"
        ></v-textarea>
        <v-btn @click="finish" v-if="!finishTrue">Finish</v-btn>
      </v-col>
      
      <!--
        WHEN FINISH BUTTON IS PRESSED:
          THE FOLLOWING SHOULD BE HIDDEN:
            - Finish button

          THE FOLLOWING SHOULD BE LOADED:
            - Download Essay button
            - Stats Card
      -->
    </v-row>  
    <v-row class="text-center" v-if="finishTrue">

      <v-col class="mb-5" cols="12">

      <!--
        Download essay as a .docx file. I successfully did this with docx.js,
        however I failed to format the file correctly so that it broke it into 
        paragraphs, as it is in the textarea.
        The file should contain the quotes at the top of the file, followed by
        the user's essay. 
        Maybe include the stats (below) in it too.
        There should be some embedded gamsatsimulator.com headers/footers (hrefs) 
        as the gamsat community will likely share these with each other online for
        free correcting, and it will be an easy product placement to have.
      -->
      <v-btn @click="download" color="primary" large elevation="12">
        Download Your Essay
        <v-icon
        right
        dark
      >
        mdi-cloud-download
      </v-icon>
      </v-btn>
      </v-col>
      <v-col class="mb-5" cols="12">
      <v-btn href="https://discord.com/channels/903408038935953438/911460503845490698" target="_blank" color="#5865F2" dark large elevation="12">
        Open Discord
      </v-btn>
      </v-col>
      <!--
        A little stats section that runs once the user hits the finish button.
        Assesses word count, number of misspelt words. 
        This section would be a nice to have, not vital. 
      -->
      <v-col class="mb-5" cols="12">
        <v-card
        elevation="2"
        shaped
        color="blue lighten-3"
        >
<v-list-item three-line>
      <v-list-item-content>
        <div class="text-overline mb-4">
          YOUR STATS
        </div>
        <v-list-item-title class="text-p mb-1">
          Word Count
        </v-list-item-title>
       <v-list-item-subtitle class="text-p mb-2"> {{ wordCountValue }}</v-list-item-subtitle>
       <v-list-item-title class="text-p mb-1">
          Essay Topic
        </v-list-item-title>
        <v-list-item-subtitle class="text-p mb-2"> {{ themeOutput }} </v-list-item-subtitle>
        <v-list-item-title class="text-p mb-1">
          Time Remaining
        </v-list-item-title>
        <v-list-item-subtitle class="text-p mb-2">{{ minutesRemaining }}:{{ secondsRemaining }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
      </v-card>
      </v-col>

      <v-col class="mb-5" cols="12">

      <!--
        Do anoter essay. Send user back to the start.
        Alert the user to ask if they wish to download their recently finished essay
        before leaving the page.

      -->
      <v-btn href="/">
        Write another essay
      </v-btn>
      </v-col>
    </v-row>

  </v-container>

</template>

<script>
import { AlignmentType, Document, Header, Packer, Paragraph, TextRun } from "docx";
import QuoteDataService from '../services/QuoteDataService';
const FileSaver = require("file-saver");

  export default {
  
  
    name: 'HelloWorld',
    methods: {

      getRandomIndexSelection(length) {
        const resultIndexes = []
        let i = 0
        for (; i < 4 && i < length; i++) {
          let temp = Math.floor(Math.random() * length)
          if(resultIndexes.indexOf(temp) !== -1){
            i--
          }
          else {
            resultIndexes.push(temp)
          }
        }
        return resultIndexes

      },

      async asyncLoadQuotes() {
        
          // select random category in the mongodb database
          // load 4 quotes that match this category
          try {
            if (this.isRandomTheme || this.themeSelected === ""){
              this.isRandomTheme = true
              var index = Math.floor(Math.random() * 40) + 1
              console.log(index)
            }
            else {
              index = this.categoryDictionary[this.themeSelected]
            }
            
            this.themeOutput = this.categoryArray[index]
            // this.themeSelected = this.categoryArray[index]
            const dto = await QuoteDataService.findByTheme(index)
            const data = dto.data

            // Here we need to pick 4 random quotes
            const resultIndexes = this.getRandomIndexSelection(data.length)
            for (let i = 0; i < 4; i++){
              const k = data[resultIndexes[i]]['author']
              const v = data[resultIndexes[i]]['quote']
              this.quoteArray[k] = v
            }
            this.dataFetched = true

          } catch (err) {
            console.log(err)
          }

      },

      // checking if data is fetched 
      checkFlag() {
    if(this.dataFetched === false) {
       window.setTimeout(this.checkFlag, 1000); 
      } else {
          this.beginTimer()
          this.beginTrue = true
          this.finishTrue = false
          this.dataFetched = false
          this.queryPendingMessage = ''
        }
      },

      begin() {
        this.beginDialog = true
        this.asyncLoadQuotes()
        this.checkFlag()
      },       
      
      finish() {
        this.finishTrue = true
      },

      download() {
        let splitTextArray = this.essayText.split("\n")
        console.log(splitTextArray)
        let numberOfParagraphs = splitTextArray.length
        console.log(numberOfParagraphs)
        let quoteArray = this.quoteArray
              
        if (numberOfParagraphs === 1 || numberOfParagraphs > 10) {      
              const doc = new Document({
          sections: [{
            headers: {
              default: new Header({
                children: [new Paragraph("gamsatsimulator.com")]
              }),
            },
            properties: {},
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Gamsat Simulator: Section II",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Topic: " + this.themeOutput,
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "Comments:",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[0]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[1]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[2]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[3]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "",
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Essay Content:",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              // Need to change the below paragraph so that it splits the
              // essayText value into paragraphs based on each newline
              new Paragraph({
                children: [
                  new TextRun({
                    text: this.essayText,
                    font: "Calibri"
                    }),
                ],
              }),
            ],
          },
        ],
      });
      const mimeType =
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const fileName = this.themeOutput + " Essay.docx";
      Packer.toBlob(doc).then((blob) => {
        const docblob = blob.slice(0, blob.size, mimeType);
        FileSaver.saveAs(docblob, fileName);
      });
        
      } else if (numberOfParagraphs === 2) {
              const doc = new Document({
          sections: [{
            headers: {
              default: new Header({
                children: [new Paragraph("gamsatsimulator.com")]
              }),
            },
            properties: {},
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Gamsat Simulator: Section II",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Topic: " + this.themeOutput,
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "Comments:",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[0]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[1]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[2]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[3]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "",
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Essay Content:",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              // Need to change the below paragraph so that it splits the
              // essayText value into paragraphs based on each newline
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[0],
                    font: "Calibri"
                    }),
                ],
              }),
                new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[1],
                    font: "Calibri"
                    }),
                ],
              }),
            ],
          },
        ],
      });
      const mimeType =
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const fileName = this.themeOutput + " Essay.docx";
      Packer.toBlob(doc).then((blob) => {
        const docblob = blob.slice(0, blob.size, mimeType);
        FileSaver.saveAs(docblob, fileName);
      });        
      } else if (numberOfParagraphs === 3) {
              const doc = new Document({
          sections: [{
            headers: {
              default: new Header({
                children: [new Paragraph("gamsatsimulator.com")]
              }),
            },
            properties: {},
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Gamsat Simulator: Section II",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Topic: " + this.themeOutput,
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "Comments:",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[0]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[1]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[2]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[3]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "",
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Essay Content:",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              // Need to change the below paragraph so that it splits the
              // essayText value into paragraphs based on each newline
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[0],
                    font: "Calibri"
                    }),
                ],
              }),
                new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[1],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[2],
                    font: "Calibri"
                    }),
                ],
              }),
            ],
          },
        ],
      });
      const mimeType =
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const fileName = this.themeOutput + " Essay.docx";
      Packer.toBlob(doc).then((blob) => {
        const docblob = blob.slice(0, blob.size, mimeType);
        FileSaver.saveAs(docblob, fileName);
      });        
      } else if (numberOfParagraphs === 4) {
              const doc = new Document({
          sections: [{
            headers: {
              default: new Header({
                children: [new Paragraph("gamsatsimulator.com")]
              }),
            },
            properties: {},
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Gamsat Simulator: Section II",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Topic: " + this.themeOutput,
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "Comments:",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[0]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[1]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[2]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[3]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "",
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Essay Content:",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              // Need to change the below paragraph so that it splits the
              // essayText value into paragraphs based on each newline
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[0],
                    font: "Calibri"
                    }),
                ],
              }),
                new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[1],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[2],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[3],
                    font: "Calibri"
                    }),
                ],
              }),
            ],
          },
        ],
      });
      const mimeType =
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const fileName = this.themeOutput + " Essay.docx";
      Packer.toBlob(doc).then((blob) => {
        const docblob = blob.slice(0, blob.size, mimeType);
        FileSaver.saveAs(docblob, fileName);
      });        
      } else if (numberOfParagraphs === 5) {
              const doc = new Document({
          sections: [{
            headers: {
              default: new Header({
                children: [new Paragraph("gamsatsimulator.com")]
              }),
            },
            properties: {},
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Gamsat Simulator: Section II",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Topic: " + this.themeOutput,
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "Comments:",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[0]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[1]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[2]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[3]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "",
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Essay Content:",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              // Need to change the below paragraph so that it splits the
              // essayText value into paragraphs based on each newline
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[0],
                    font: "Calibri"
                    }),
                ],
              }),
                new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[1],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[2],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[3],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[4],
                    font: "Calibri"
                    }),
                ],
              }),
            ],
          },
        ],
      });
      const mimeType =
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const fileName = this.themeOutput + " Essay.docx";
      Packer.toBlob(doc).then((blob) => {
        const docblob = blob.slice(0, blob.size, mimeType);
        FileSaver.saveAs(docblob, fileName);
      });        
      } else if (numberOfParagraphs === 6) {
              const doc = new Document({
          sections: [{
            headers: {
              default: new Header({
                children: [new Paragraph("gamsatsimulator.com")]
              }),
            },
            properties: {},
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Gamsat Simulator: Section II",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Topic: " + this.themeOutput,
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "Comments:",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[0]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[1]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[2]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[3]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "",
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Essay Content:",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              // Need to change the below paragraph so that it splits the
              // essayText value into paragraphs based on each newline
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[0],
                    font: "Calibri"
                    }),
                ],
              }),
                new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[1],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[2],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[3],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[4],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[5],
                    font: "Calibri"
                    }),
                ],
              }),
            ],
          },
        ],
      });
      const mimeType =
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const fileName = this.themeOutput + " Essay.docx";
      Packer.toBlob(doc).then((blob) => {
        const docblob = blob.slice(0, blob.size, mimeType);
        FileSaver.saveAs(docblob, fileName);
      });        
      } else if (numberOfParagraphs === 7) {
              const doc = new Document({
          sections: [{
            headers: {
              default: new Header({
                children: [new Paragraph("gamsatsimulator.com")]
              }),
            },
            properties: {},
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Gamsat Simulator: Section II",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Topic: " + this.themeOutput,
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "Comments:",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[0]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[1]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[2]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[3]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "",
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Essay Content:",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              // Need to change the below paragraph so that it splits the
              // essayText value into paragraphs based on each newline
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[0],
                    font: "Calibri"
                    }),
                ],
              }),
                new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[1],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[2],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[3],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[4],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[5],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[6],
                    font: "Calibri"
                    }),
                ],
              }),
            ],
          },
        ],
      });
      const mimeType =
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const fileName = this.themeOutput + " Essay.docx";
      Packer.toBlob(doc).then((blob) => {
        const docblob = blob.slice(0, blob.size, mimeType);
        FileSaver.saveAs(docblob, fileName);
      });        
      } else if (numberOfParagraphs === 8) {
              const doc = new Document({
          sections: [{
            headers: {
              default: new Header({
                children: [new Paragraph("gamsatsimulator.com")]
              }),
            },
            properties: {},
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Gamsat Simulator: Section II",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Topic: " + this.themeOutput,
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "Comments:",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[0]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[1]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[2]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[3]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "",
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Essay Content:",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              // Need to change the below paragraph so that it splits the
              // essayText value into paragraphs based on each newline
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[0],
                    font: "Calibri"
                    }),
                ],
              }),
                new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[1],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[2],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[3],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[4],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[5],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[6],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[7],
                    font: "Calibri"
                    }),
                ],
              }),
            ],
          },
        ],
      });
      const mimeType =
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const fileName = this.themeOutput + " Essay.docx";
      Packer.toBlob(doc).then((blob) => {
        const docblob = blob.slice(0, blob.size, mimeType);
        FileSaver.saveAs(docblob, fileName);
      });        
      } else if (numberOfParagraphs === 9) {
              const doc = new Document({
          sections: [{
            headers: {
              default: new Header({
                children: [new Paragraph("gamsatsimulator.com")]
              }),
            },
            properties: {},
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Gamsat Simulator: Section II",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Topic: " + this.themeOutput,
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "Comments:",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[0]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[1]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[2]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[3]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "",
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Essay Content:",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              // Need to change the below paragraph so that it splits the
              // essayText value into paragraphs based on each newline
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[0],
                    font: "Calibri"
                    }),
                ],
              }),
                new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[1],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[2],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[3],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[4],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[5],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[6],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[7],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[8],
                    font: "Calibri"
                    }),
                ],
              }),
            ],
          },
        ],
      });
      const mimeType =
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const fileName = this.themeOutput + " Essay.docx";
      Packer.toBlob(doc).then((blob) => {
        const docblob = blob.slice(0, blob.size, mimeType);
        FileSaver.saveAs(docblob, fileName);
      });        
      } else if (numberOfParagraphs === 10) {
              const doc = new Document({
          sections: [{
            headers: {
              default: new Header({
                children: [new Paragraph("gamsatsimulator.com")]
              }),
            },
            properties: {},
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Gamsat Simulator: Section II",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Topic: " + this.themeOutput,
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "Comments:",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[0]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[1]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[2]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                bullet: {level: 0},
                children: [
                  new TextRun({
                    text: quoteArray[Object.keys(quoteArray)[3]],
                    font: "Calibri"
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "",
              }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Essay Content:",
                    bold: true,
                    font: "Calibri"
              }),
                ],
              }),
              // Need to change the below paragraph so that it splits the
              // essayText value into paragraphs based on each newline
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[0],
                    font: "Calibri"
                    }),
                ],
              }),
                new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[1],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[2],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[3],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[4],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[5],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[6],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[7],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[8],
                    font: "Calibri"
                    }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: splitTextArray[9],
                    font: "Calibri"
                    }),
                ],
              }),
            ],
          },
        ],
      });
      const mimeType =
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const fileName = this.themeOutput + " Essay.docx";
      Packer.toBlob(doc).then((blob) => {
        const docblob = blob.slice(0, blob.size, mimeType);
        FileSaver.saveAs(docblob, fileName);
      });        
      }
       
      },

      beginTimer() {
        this.countDown = 32.5 * 60
        this.countDownTimer()
      },

      countDownTimer() {
        if(this.countDown > 0 && this.finishTrue === false){
          var timer = setTimeout(() => {
              this.countDown -= 1
              this.countDownTimer()
              var minutes = parseInt(this.countDown / 60, 10);
              var seconds = parseInt(this.countDown % 60, 10);

              minutes = minutes < 10 ? "0" + minutes : minutes;
              seconds = seconds < 10 ? "0" + seconds : seconds;
        
              this.minutesRemaining = minutes
              this.secondsRemaining = seconds

              if (this.minutesRemaining == '00' && this.secondsRemaining == '00') {
                this.timesUp = true
              }

          }, 1000)
        }
        else {
          clearTimeout(timer)
        }
      },

      wordCount() {
        this.wordCountValue = this.essayText.split(" ").length
        return this.essayText.split(" ").length
      }

    },
    data: () => ({
      beginDialog: false,
      dialog: false,
      categoryDictionary: {"Random Topic (Recommended)": "0",
      "Law and Justice": "1",
      "Welfare": "2",
      "Gender": "3",
      "Collectivism": "4",
      "War": "5",
      "Leadership": "6",
      "Journalism/News": "7",
      "Cynicism": "8",
      "Love": "9",
      "Food": "10",
      "Solitude": "11",
      "Family": "12",
      "Altruism": "13",
      "Arts & Pop Culture": "14",
      "Personality": "15",
      "Moralising": "16",
      "Tolerance": "17",
      "Mercy": "18",
      "Civility": "19",
      "Compromise": "20",
      "Fear": "21",
      "Courage": "22",
      "Defeat": "23",
      "Sorrow": "24",
      "Death": "25",
      "Hope": "26",
      "Perseverance": "27",
      "Prudence": "28",
      "Frankness": "29",
      "Lying": "30",
      "Perjury": "31",
      "Betrayal": "32",
      "Loyalty": "33",
      "Blame": "34",
      "Punishment": "35",
      "Delusion": "36",
      "Happiness": "37",
      "Nationalism": "38",
      "Racism": "39",
      "Speciesism": "40"},
      categoryArray: ["Random Topic (Recommended)",
      "Law and Justice",
      "Welfare",
      "Gender",
      "Collectivism",
      "War",
      "Leadership",
      "Journalism/News",
      "Cynicism",
      "Love",
      "Food",
      "Solitude",
      "Family",
      "Altruism",
      "Arts & Pop Culture",
      "Personality",
      "Moralising",
      "Tolerance",
      "Mercy",
      "Civility",
      "Compromise",
      "Fear",
      "Courage",
      "Defeat",
      "Sorrow",
      "Death",
      "Hope",
      "Perseverance",
      "Prudence",
      "Frankness",
      "Lying",
      "Perjury",
      "Betrayal",
      "Loyalty",
      "Blame",
      "Punishment",
      "Delusion",
      "Happiness",
      "Nationalism",
      "Racism",
      "Speciesism",],
      quoteArray: [],
      themeSelected: "",
      themeOutput: "Random Topic (Recommended)",
      dataFetched: false,
      queryPendingMessage: "",
      beginTrue: false,
      isRandomTheme: true,
      finishTrue: false,
      timesUp: false,
      minutesRemaining: "",
      secondsRemaining: "",
      duration: "",
      countDown: 0,
      essayText: "",
      wordCountValue: 0,
      // These are all of the relevant themes at present.
      // Loading them from the DB would be much better
      themes: [
        {
          text: 'Law and Justice',
        },
        {
          text: 'Welfare',
        },
        {
          text: 'Gender',
        },
        {
          text: 'Collectivism',
        },
        {
          text: 'War',
        },
        {
          text: 'Leadership',
        },
        {
          text: 'Journalism/News',
        },
        {
          text: 'Cynicism',
        },
        {
          text: 'Love',
        },
        {
          text: 'Food',
        },
        {
          text: 'Solitude',
        },
        {
          text: 'Family',
        },
        {
          text: 'Altruism',
        },
        {
          text: 'Arts & Pop Culture',
        },
        {
          text: 'Personality',
        },
        {
          text: 'Moralising',
        },
        {
          text: 'Tolerance',
        },
        {
          text: 'Mercy',
        },
        {
          text: 'Civility',
        },
        {
          text: 'Compromise',
        },
        {
          text: 'Fear',
        },
        {
          text: 'Courage',
        },
        {
          text: 'Defeat',
        },
        {
          text: 'Sorrow',
        },
        {
          text: 'Death',
        },
        {
          text: 'Hope',
        },
        {
          text: 'Perseverance',
        },
        {
          text: 'Prudence',
        },
        {
          text: 'Frankness',
        },
        {
          text: 'Lying',
        },
        {
          text: 'Perjury',
        },
        {
          text: 'Betrayal',
        },
        {
          text: 'Loyalty',
        },
        {
          text: 'Blame',
        },
        {
          text: 'Punishment',
        },
        {
          text: 'Delusion',
        },
        {
          text: 'Happiness',
        },
        {
          text: 'Nationalism',
        },
        {
          text: 'Racism',
        },
        {
          text: 'Speciesism',
        },
      ],
    }),
  }
</script>
